export const invoiceSymbolRecordStatus = [
  { key: "O", badgeColor: "badge-soft-success" },
  { key: "C", badgeColor: "badge-soft-danger" },
];

export const invoiceSymbolType = [
  { key: "0", badgeColor: "badge-soft-success" },
  { key: "1", badgeColor: "badge-soft-info" },
];

export const invoiceSymbolRecordStatusMode = {
  ACTIVE: "O",
  INACTIVE: "C",
};

export const invoiceSymbolModeList = {
  CREATE_INVOICE_SYMBOL_DETAIL: "CREATE_INVOICE_SYMBOL_DETAIL",
  VIEW_INVOICE_SYMBOL_DETAIL: "VIEW_INVOICE_SYMBOL_DETAIL",
  EDIT_INVOICE_SYMBOL_DETAIL: "EDIT_INVOICE_SYMBOL_DETAIL",
};

export const KyHieuMauHoaDonMode = {
  VAT_INVOICE: "1",
  SALE_INVOICE: "2",
  TICKETS_INVOICE: "5",
  DELIVERY_BILL: "6",
  TAX_DEDUCT: "ct",
};
export const KyHieuMauHoaDonList = [{ value: "1", label: "" }];
